export const siteConst ={
    
    ADD_SITE:                           'ADD_SITE_REQUEST',
    ADD_SITE_SUCCESS:                   'ADD_SITE_SUCCESS',
    ADD_SITE_FAILURE:                   'ADD_SITE_FAILURE',

   	GETCOUNTRY_REQUEST:                 'SITE_GETCOUNTRY_REQUEST',
    GETCOUNTRY_SUCCESS:                 'SITE_GETCOUNTRY_SUCCESS',
    GETCOUNTRY_FAILURE:                 'SITE_GETCOUNTRY_FAILURE',

    GET_SITE_DETAILS_REQUEST:           'GET_SITE_DETAILS_REQUEST',
    GET_SITE_DETAILS_SUCCESS:           'GET_SITE_DETAILS_SUCCESS',
    GET_SITE_DETAILS_FAILURE:           'GET_SITE_DETAILS_FAILURE',

    UPDATE_SITE_REQUEST:                'UPDATE_SITE_REQUEST',
    UPDATE_SITE_SUCCESS:                'UPDATE_SITE_SUCCESS',
    UPDATE_SITE_FAILURE:                'UPDATE_SITE_FAILURE',

    GET_DASHBOARD_DETAILS_REQUEST:      'GET_DASHBOARD_DETAILS_REQUEST',
    GET_DASHBOARD_DETAILS_SUCCESS:      'GET_DASHBOARD_DETAILS_SUCCESS',
    GET_DASHBOARD_DETAILS_FAILURE:      'GET_DASHBOARD_DETAILS_FAILURE',

    GET_CUSTOMER_DATA_REQUEST:          'GET_CUSTOMER_DATA_REQUEST',
    GET_CUSTOMER_DATA_SUCCESS:          'GET_CUSTOMER_DATA_SUCCESS',
    GET_CUSTOMER_DATA_FAILURE:          'GET_CUSTOMER_DATA_FAILURE',

    CHECK_SITE_STATUS_REQUEST:          'CHECK_SITE_STATUS_REQUEST',
    CHECK_SITE_STATUS_SUCCESS:          'CHECK_SITE_STATUS_SUCCESS',
    CHECK_SITE_STATUS_FAILURE:          'CHECK_SITE_STATUS_FAILURE',

    GET_FORMSETTING_REQUEST:            'GET_FORMSETTING_REQUEST',
    GET_FORMSETTING_SUCCESS:            'GET_FORMSETTING_SUCCESS',
    GET_FORMSETTING_FAILURE:            'GET_FORMSETTING_FAILURE',
    
    POST_FORMSETTING_REQUEST:           'POST_FORMSETTING_REQUEST',
    POST_FORMSETTING_SUCCESS:           'POST_FORMSETTING_SUCCESS',
    POST_FORMSETTING_FAILURE:           'POST_FORMSETTING_FAILURE',

    GET_LOOKUP_DATA_REQUEST:          'GET_LOOKUP_DATA_REQUEST',
    GET_LOOKUP_DATA_SUCCESS:          'GET_LOOKUP_DATA_SUCCESS',
    GET_LOOKUP_DATA_FAILURE:          'GET_LOOKUP_DATA_FAILURE',

    GET_APISETTING_REQUEST:             'GET_APISETTING_REQUEST',
    GET_APISETTING_SUCCESS:             'GET_APISETTING_SUCCESS',
    GET_APISETTING_FAILURE:             'GET_APISETTING_FAILURE',

    POST_APISETTING_REQUEST:            'POST_APISETTING_REQUEST',
    POST_APISETTING_SUCCESS:            'POST_APISETTING_SUCCESS',
    POST_APISETTING_FAILURE:            'POST_APISETTING_FAILURE',
    POST_ROLELIST_REQUEST:              'POST_ROLELIST_REQUEST',
    POST_ROLELIST_SUCCESS:              'POST_ROLELIST_SUCCESS',
    POST_ROLELIST_FAILURE:              'POST_ROLELIST_FAILURE',
    POST_ROLESTATUS_REQUEST:            'POST_ROLESTATUS_REQUEST',
    POST_ROLESTATUS_SUCCESS:            'POST_ROLESTATUS_SUCCESS',
    POST_ROLESTATUS_FAILURE:            'POST_ROLESTATUS_FAILURE',
    POST_SSL_REQUEST:                   'POST_SSL_REQUEST',
    POST_SSL_SUCCESS:                   'POST_SSL_SUCCESS',
    POST_SSL_FAILURE:                   'POST_SSL_FAILURE',
    POST_ACCOUNT_SETTING_REQUEST:       'POST_ACCOUNT_SETTING_REQUEST' ,
    POST_ACCOUNT_SETTING_SUCCESS:       'POST_ACCOUNT_SETTING_SUCCESS',
    POST_ACCOUNT_SETTING_FAILURE:       'POST_ACCOUNT_SETTING_FAILURE'  
};


// WEBPACK FOOTER //
// ./src/app/redux/constants/siteConst.js